import { AccessProvider } from 'contexts/providers/AccessProvider'
import { AuthProvider } from 'contexts/providers/AuthProvider'
import { BulkUploadProvider } from 'contexts/providers/BulkUploadProvider'
import { CurrenciesProvider } from 'contexts/providers/CurrenciesProvider'
import { DynamicPricesProvider } from 'contexts/providers/DynamicPricesProvider'
import { OnboardingProvider } from 'contexts/providers/OnboardingProvider'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()

type Props = {
  children: React.ReactNode
}

export const Providers = ({ children }: Props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <OnboardingProvider>
          <AccessProvider>
            <CurrenciesProvider>
              <DynamicPricesProvider>
                <BulkUploadProvider>{children}</BulkUploadProvider>
              </DynamicPricesProvider>
            </CurrenciesProvider>
          </AccessProvider>
        </OnboardingProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
